import {
  ButtonLooks,
  ButtonSizes,
  DialogSizes,
  StandardButton,
  StandardDialog,
  brandfolderColorPalette
} from '@brandfolder/react';
import { t, Trans } from '@lingui/macro';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

const MergePeopleModalWrapper = styled(StandardDialog)`
  .bf-dialog__heading {
    font-size: 24px;
    font-weight: bold;
  }

  .bf-dialog__type--modal {
    height: auto;
  }

  .bf-dialog__header {
    background-color: ${brandfolderColorPalette.neutrals[0]};
    padding: 0 15px;
  }

  .bf-dialog__body {
    margin-top: 18px;
    padding: 0 30px;
  }

  .bf-dialog__footer {
    text-align: end;

    button {
      &:not(:last-child) {
        margin-right: 16px;
      }
    }
  }
`;

const ContentRow = styled.div`
  align-items: flex-start;
  display: flex;
  gap: 16px;
`;

const ThumbnailsContainer = styled.div`
  display: flex;
  gap: 8px;
`;

const Thumbnail = styled.img`
  border-radius: 4px;
  height: 60px;
  object-fit: cover;
  width: 60px;
`;

const DescriptionText = styled.p`
  color: ${brandfolderColorPalette.neutrals[700]};
  font-size: 16px;
  font-weight: 450;
  line-height: 20px;
  margin: 0;
`;

interface MergePeopleModalProps {
  currentPersonThumbnail: string;
  handleCancelMerge: () => void;
  handleMerge: () => void;
  isOpen: boolean;
  targetPersonThumbnail: string;
}

export const MergePeopleModal: FunctionComponent<MergePeopleModalProps> = ({
  currentPersonThumbnail,
  handleCancelMerge,
  handleMerge,
  isOpen,
  targetPersonThumbnail
}) => (
  <MergePeopleModalWrapper
    className="merge-people-modal"
    footer={
      <>
        <StandardButton
          look={ButtonLooks.Secondary}
          onClick={handleCancelMerge}
          size={ButtonSizes.XSmall}
        >
          <Trans>Keep them separate</Trans>
        </StandardButton>
        <StandardButton
          look={ButtonLooks.Primary}
          onClick={handleMerge}
          size={ButtonSizes.XSmall}
        >
          <Trans>Merge people</Trans>
        </StandardButton>
      </>
    }
    id="merge-people-modal"
    labels={{
      closeButtonLabel: 'Close'
    }}
    open={isOpen}
    setOpen={handleCancelMerge}
    showTitle={true}
    size={DialogSizes.Small}
    title={t`Merge these people?`}
  >
    <ContentRow>
      <ThumbnailsContainer>
        <Thumbnail alt="current person" src={currentPersonThumbnail} />
        <Thumbnail alt="target person" src={targetPersonThumbnail} />
      </ThumbnailsContainer>

      <DescriptionText>
        <Trans>
          You can either merge them together, or keep them as separate people tags with the same name.
        </Trans>
      </DescriptionText>
    </ContentRow>
  </MergePeopleModalWrapper>
);
